import { render } from "./GoogleCalendarEmbed.vue?vue&type=template&id=6ecb84f8&scoped=true"
import script from "./GoogleCalendarEmbed.vue?vue&type=script&lang=js"
export * from "./GoogleCalendarEmbed.vue?vue&type=script&lang=js"

import "./GoogleCalendarEmbed.vue?vue&type=style&index=0&id=6ecb84f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecb84f8"]])

export default __exports__